<script setup>
defineProps({
    items: {
        type: Array,
        required: true,
    },
    title: {
        type: String,
        default: "Veelgestelde vragen",
    },
    intro: {
        type: String,
        default: null,
    },
    eyebrow: {
        type: String,
        default: "FAQ",
    },
});
</script>

<template>
  <section class="bg-white py-20 sm:py-24">
    <div class="mx-auto max-w-4xl px-6 lg:px-8">
      <div class="mx-auto max-w-2xl text-center">
        <p class="text-sm font-semibold uppercase tracking-wide text-indigo-600">
          {{ eyebrow }}
        </p>
        <h2 class="mt-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
          {{ title }}
        </h2>
        <p
          v-if="intro"
          class="mt-4 text-lg text-gray-600"
        >
          {{ intro }}
        </p>
      </div>
      <div class="mt-12 divide-y divide-gray-200 border-t border-gray-200">
        <details
          v-for="item in items"
          :key="item.q"
          class="group py-6"
        >
          <summary class="flex cursor-pointer list-none items-center justify-between text-left text-base font-semibold text-gray-900 marker:hidden">
            <span>{{ item.q }}</span>
            <span class="ml-6 flex h-7 w-7 flex-none items-center justify-center rounded-full bg-gray-50 text-gray-500 group-open:bg-indigo-50 group-open:text-indigo-600">
              <svg
                class="h-4 w-4 transition-transform duration-200 group-open:rotate-45"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>
            </span>
          </summary>
          <p class="mt-3 pr-9 text-base leading-7 text-gray-600">
            {{ item.a }}
          </p>
        </details>
      </div>
    </div>
  </section>
</template>

<style scoped>
summary::-webkit-details-marker {
    display: none;
}
</style>
